<template>
    <div class="setting-title">
        <div class="title-tip">找到靠谱的服务商，从一个有吸引力的标题开始，好的标题有助于你的需求脱颖而出，吸引优质服务商参与。</div>

        <div class="setting-box">
            <div class="setting-box_form">
                <h1 class="form-title">一句话描述你的需求</h1>

                <el-input v-model="task_name" placeholder="例：餐饮公司品牌logo设计" maxlength="20" show-word-limit></el-input>

                <div class="form-desc">
                    <div class="desc-label">你可以这么描述</div>

                    <ol>
                        <li v-for="item in descExample" :key="item">{{ item }}</li>
                    </ol>
                </div>

                <!-- 设置类型 -->
                <div class="form-type">
                    <div class="type-label">{{ !task_type ? "请设置需求类型" : "已选择" }}</div>
                    <div class="change-types">{{ typeName }}</div>
                    <div class="change-btn" @click="dialogVisible = true">选择类型</div>
                </div>

                <div class="form-submit">
                    <div class="submit-btn cancel" @click="handleCancel">取消</div>
                    <div :class="['submit-btn', 'next', { disabled: !task_name || !task_type }]" @click="handleNext">下一步，招募</div>
                </div>
            </div>

            <div class="setting-box_icon">
                <img src="@/assets/img/task-center/demand-widget-1.png" alt="" />
            </div>
        </div>

        <ChangeTypeDialog
            v-model="dialogVisible"
            :list="classList"
            :type="task_type"
            @confirm="($event) => (task_type = $event)"
        ></ChangeTypeDialog>
    </div>
</template>

<script>
import ChangeTypeDialog from "./ChangeTypeDialog.vue";
import { request } from "../../util";

export default {
    data() {
        return {
            task_name: "",
            task_type: null,
            descExample: ["某公司企业官网开发", "出10张风格不同的海报设计", "新媒体公众号文案撰写每月三篇"],
            dialogVisible: false,
            classList: [],

            request: request(),
        };
    },

    components: {
        ChangeTypeDialog,
    },

    computed: {
        // 选中类型的name
        typeName() {
            if (!this.task_type) return "";

            const childrenList = this.classList.flatMap((item) => item.children);
            const checkType = childrenList.find((item) => item.id === this.task_type);

            return checkType?.name || "";
        },
    },

    created() {
        this.getClassList();
    },

    methods: {
        handleNext() {
            if (!this.task_name || !this.task_type) {
                this.$message.warning("请填写完整数据");
                return;
            }

            this.$emit("next", { task_name: this.task_name, task_type: this.task_type });
        },

        handleCancel() {
            this.$emit("cancel");
        },

        // 获取分类
        getClassList() {
            const params = {
                paging: 0,
                class_type: 2,
            };

            this.request.axiosGetBy(this.$api.classification, params, (res) => {
                if (res.code === 200) {
                    this.classList = (res.data?.data || []).map((item) => {
                        const children =
                            item.subClassification?.map((c) => ({
                                id: c.id,
                                name: c.name,
                            })) || [];

                        const classItem = {
                            id: item.id,
                            name: item.name,
                            children: children,
                        };

                        return classItem;
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        initData(data) {
            this.task_name = data.task_name;
            this.task_type = data.task_type;
        },
    },
};
</script>

<style lang="scss" scoped>
.setting-title {
    box-sizing: border-box;
    padding-left: 60px;
    height: 100%;
    width: 100%;
    // border: 1px solid black;

    .title-tip {
        height: 50px;
        background: #eff6ff;
        border-radius: 4px;
        border: 2px solid #c3dfff;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }

    .setting-box {
        display: flex;
        gap: 30px;

        &_form {
            flex: 1;

            .form-title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 36px;
                color: #333333;
            }

            .el-input {
                width: 480px;
            }

            .form-desc {
                .desc-label {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    padding-block: 30px 16px;
                }

                ol {
                    padding-left: 20px;

                    li {
                        list-style-type: disc;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                        & + li {
                            margin-top: 10px;
                        }
                    }
                }
            }

            .form-type {
                margin-top: 30px;
                display: flex;
                gap: 10px;

                .type-label {
                    flex-shrink: 0;
                }

                .change-types {
                    color: #999999;
                    line-height: 20px;
                }

                .change-btn {
                    color: #4d5aff;
                    cursor: pointer;
                    flex-shrink: 0;
                }
            }

            .form-submit {
                margin-top: 80px;
                display: flex;
                gap: 8px;

                .submit-btn {
                    padding: 1px 20px;
                    border-radius: 16px;
                    border: none;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 30px;
                    cursor: pointer;

                    &.cancel {
                        color: #333333;
                        background: #f5f7fa;
                        border: 1px solid #dcdfe6;
                    }

                    &.next {
                        background: #594fed;
                        color: #ffffff;

                        &.disabled {
                            cursor: not-allowed;
                            opacity: 0.4;
                        }
                    }
                }
            }
        }

        &_icon {
            width: 550px;
            display: flex;
            align-items: flex-end;

            img {
                width: 550px;
                object-fit: contain;
            }
        }
    }
}

::v-deep(.el-dialog__body) {
    padding-top: 10px;
}
</style>
